function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var SaitoOverlay = require('./../../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SignatureFieldTemplate = require('./signature.template');
var _require = require('../../script_build'),
  isPlaceholder = _require.isPlaceholder;
var _require2 = require('../../unlock_tx_fee'),
  prepareUnlockForSigning = _require2.prepareUnlockForSigning,
  markUnlockImmutable = _require2.markUnlockImmutable,
  ensureDefaultUnlockFee = _require2.ensureDefaultUnlockFee;
function pickPublicKey(value) {
  if (typeof value !== 'string') {
    return '';
  }
  var s = value.trim();
  if (!s || isPlaceholder(s)) {
    return '';
  }
  return s;
}
function pickMessage(value) {
  if (typeof value !== 'string') {
    return '';
  }
  var s = value.trim();
  if (!s || isPlaceholder(s)) {
    return '';
  }
  return s;
}
function getAtPath(root, pathParts) {
  var cursor = root;
  var _iterator = _createForOfIteratorHelper(pathParts),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (cursor == null) {
        return undefined;
      }
      cursor = cursor[key];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return cursor;
}
function findSignatureContext(script, dotPath) {
  var _node$msg, _script$msg;
  if (!script || !dotPath) {
    return {
      message: '',
      requiredPublicKeys: []
    };
  }
  var pathParts = String(dotPath).split('.');
  var nodePath = pathParts.slice();
  var last = nodePath[nodePath.length - 1];
  if (last === 'signature') {
    nodePath.pop();
    if (nodePath[nodePath.length - 1] === 'witness' || nodePath[nodePath.length - 1] === 'required') {
      nodePath.pop();
    }
  } else if (typeof last === 'number' && nodePath[nodePath.length - 2] === 'signatures') {
    nodePath.pop();
    nodePath.pop();
    if (nodePath[nodePath.length - 1] === 'witness' || nodePath[nodePath.length - 1] === 'required') {
      nodePath.pop();
    }
  } else if (last === 'signatures') {
    nodePath.pop();
    if (nodePath[nodePath.length - 1] === 'witness' || nodePath[nodePath.length - 1] === 'required') {
      nodePath.pop();
    }
  } else if (/^\d+$/.test(String(last)) && nodePath[nodePath.length - 2] === 'signatures') {
    nodePath.pop();
    nodePath.pop();
    if (nodePath[nodePath.length - 1] === 'witness' || nodePath[nodePath.length - 1] === 'required') {
      nodePath.pop();
    }
  }
  var node = getAtPath(script, nodePath);
  var requiredPublicKeys = [];
  if (node && _typeof(node) === 'object') {
    var pk = pickPublicKey(node.publickey);
    if (pk) {
      requiredPublicKeys.push(pk);
    }
    if (Array.isArray(node.publickeys)) {
      var _iterator2 = _createForOfIteratorHelper(node.publickeys),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var k = pickPublicKey(key);
          if (k && !requiredPublicKeys.includes(k)) {
            requiredPublicKeys.push(k);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }
  var message = node && pickMessage((_node$msg = node.msg) !== null && _node$msg !== void 0 ? _node$msg : node.message) || pickMessage((_script$msg = script === null || script === void 0 ? void 0 : script.msg) !== null && _script$msg !== void 0 ? _script$msg : script === null || script === void 0 ? void 0 : script.message);
  return {
    message: message,
    requiredPublicKeys: requiredPublicKeys
  };
}
function walletOwnsRequiredKey(_x, _x2) {
  return _walletOwnsRequiredKey.apply(this, arguments);
}
function _walletOwnsRequiredKey() {
  _walletOwnsRequiredKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, requiredPublicKeys) {
    var _app$wallet, _app$wallet2, mine, _t3, _t4, _t5;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.p = _context6.n) {
        case 0:
          if (!(!Array.isArray(requiredPublicKeys) || requiredPublicKeys.length === 0)) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, false);
        case 1:
          _context6.p = 1;
          mine = '';
          if (!(typeof ((_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.getPublicKey) === 'function')) {
            _context6.n = 4;
            break;
          }
          _t3 = String;
          _context6.n = 2;
          return app.wallet.getPublicKey();
        case 2:
          _t4 = _context6.v;
          if (_t4) {
            _context6.n = 3;
            break;
          }
          _t4 = '';
        case 3:
          mine = _t3(_t4).trim();
          _context6.n = 5;
          break;
        case 4:
          if (typeof ((_app$wallet2 = app.wallet) === null || _app$wallet2 === void 0 ? void 0 : _app$wallet2.returnPublicKey) === 'function') {
            mine = String(app.wallet.returnPublicKey() || '').trim();
          }
        case 5:
          if (mine) {
            _context6.n = 6;
            break;
          }
          return _context6.a(2, false);
        case 6:
          return _context6.a(2, requiredPublicKeys.some(function (pk) {
            return pk === mine;
          }));
        case 7:
          _context6.p = 7;
          _t5 = _context6.v;
          return _context6.a(2, false);
      }
    }, _callee6, null, [[1, 7]]);
  }));
  return _walletOwnsRequiredKey.apply(this, arguments);
}
var SignatureFieldOverlay = /*#__PURE__*/function () {
  function SignatureFieldOverlay(app, mod) {
    _classCallCheck(this, SignatureFieldOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.path = '';
    this.currentValue = '';
    this.onApply = null;
  }
  return _createClass(SignatureFieldOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$currentValue;
        var currentValue, sigCtx, canAutoSign, pkDisplay, msgDisplay;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              currentValue = isPlaceholder(this.currentValue) ? '' : String((_this$currentValue = this.currentValue) !== null && _this$currentValue !== void 0 ? _this$currentValue : '');
              sigCtx = findSignatureContext(this.mod.getScript(), this.path);
              _context.n = 1;
              return walletOwnsRequiredKey(this.app, sigCtx.requiredPublicKeys);
            case 1:
              canAutoSign = _context.v;
              pkDisplay = sigCtx.requiredPublicKeys.length ? sigCtx.requiredPublicKeys.join(', ') : '—';
              msgDisplay = sigCtx.message || '—';
              this.overlay.show(SignatureFieldTemplate({
                pkDisplay: pkDisplay,
                msgDisplay: msgDisplay,
                canAutoSign: canAutoSign,
                currentValue: currentValue
              }));
              this.attachEvents({
                canAutoSign: canAutoSign,
                message: sigCtx.message
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
    /**
     * Unlock CHECKSIG/CHECKMULTISIG: fund fee silently, sign message|p2sh_auth_hash.
     * Create-workflow signatures still sign the plain message.
     */
  }, {
    key: "resolveSignableMessage",
    value: function () {
      var _resolveSignableMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(message) {
        var _this$mod;
        var msg, prepared;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              msg = String(message !== null && message !== void 0 ? message : '').trim();
              if (msg) {
                _context2.n = 1;
                break;
              }
              throw new Error('No signable message found for this opcode');
            case 1:
              if (!(((_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.workflow) !== 'unlock')) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, msg);
            case 2:
              ensureDefaultUnlockFee(this.mod);
              _context2.n = 3;
              return prepareUnlockForSigning(this.app, this.mod, msg);
            case 3:
              prepared = _context2.v;
              return _context2.a(2, prepared.authMessage);
          }
        }, _callee2, this);
      }));
      function resolveSignableMessage(_x3) {
        return _resolveSignableMessage.apply(this, arguments);
      }
      return resolveSignableMessage;
    }()
  }, {
    key: "applySignature",
    value: function () {
      var _applySignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(sig) {
        var _this$mod2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              // Lock before apply/refresh so the UI reflects immutability immediately.
              if (((_this$mod2 = this.mod) === null || _this$mod2 === void 0 ? void 0 : _this$mod2.workflow) === 'unlock') {
                markUnlockImmutable(this.mod);
              }
              if (typeof this.onApply === 'function') {
                this.onApply(sig);
              }
              this.overlay.hide();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function applySignature(_x4) {
        return _applySignature.apply(this, arguments);
      }
      return applySignature;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _options$message,
        _this = this,
        _root$querySelector;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var host = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var root = host === null || host === void 0 ? void 0 : host.querySelector('.rs-prompt-signature');
      var valueEl = root === null || root === void 0 ? void 0 : root.querySelector('.rs-prompt-signature-value');
      var canAutoSign = options.canAutoSign === true;
      var message = String((_options$message = options.message) !== null && _options$message !== void 0 ? _options$message : '').trim();
      var validation = root === null || root === void 0 ? void 0 : root.querySelector('.rs-prompt-validation');
      if (valueEl && typeof valueEl.focus === 'function') {
        valueEl.focus({
          preventScroll: true
        });
      }
      var showError = function showError(msg) {
        if (!validation) {
          return;
        }
        validation.hidden = false;
        validation.textContent = msg;
      };
      var clearError = function clearError() {
        if (validation) {
          validation.hidden = true;
          validation.textContent = '';
        }
      };
      valueEl === null || valueEl === void 0 || valueEl.addEventListener('input', clearError);
      var signAndApply = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var _this$app$wallet, _this$app$crypto, signable, sig, privateKey, _t;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                _context4.p = 0;
                _context4.n = 1;
                return _this.resolveSignableMessage(message);
              case 1:
                signable = _context4.v;
                sig = '';
                if (!(typeof ((_this$app$wallet = _this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.signMessage) === 'function')) {
                  _context4.n = 3;
                  break;
                }
                _context4.n = 2;
                return _this.app.wallet.signMessage(signable);
              case 2:
                sig = _context4.v;
                _context4.n = 6;
                break;
              case 3:
                if (!(typeof ((_this$app$crypto = _this.app.crypto) === null || _this$app$crypto === void 0 ? void 0 : _this$app$crypto.signMessage) === 'function')) {
                  _context4.n = 6;
                  break;
                }
                _context4.n = 4;
                return _this.app.wallet.getPrivateKey();
              case 4:
                privateKey = _context4.v;
                _context4.n = 5;
                return _this.app.crypto.signMessage(signable, privateKey);
              case 5:
                sig = _context4.v;
              case 6:
                clearError();
                _context4.n = 7;
                return _this.applySignature(sig);
              case 7:
                _context4.n = 9;
                break;
              case 8:
                _context4.p = 8;
                _t = _context4.v;
                showError(_t.message || String(_t));
              case 9:
                return _context4.a(2);
            }
          }, _callee4, null, [[0, 8]]);
        }));
        return function signAndApply() {
          return _ref.apply(this, arguments);
        };
      }();
      root === null || root === void 0 || (_root$querySelector = root.querySelector('.rs-prompt-sign-wallet')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        signAndApply();
      });
      if (!canAutoSign) {
        var _root$querySelector2;
        root === null || root === void 0 || (_root$querySelector2 = root.querySelector('.rs-prompt-apply')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          var _valueEl$value;
          var next, ok, _this$mod3, _t2;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.p = _context5.n) {
              case 0:
                next = String((_valueEl$value = valueEl === null || valueEl === void 0 ? void 0 : valueEl.value) !== null && _valueEl$value !== void 0 ? _valueEl$value : '').trim();
                if (!(!next || isPlaceholder(next))) {
                  _context5.n = 1;
                  break;
                }
                showError('A value is required');
                return _context5.a(2);
              case 1:
                ok = /^[0-9a-fA-F]+$/.test(next) && next.length >= 128;
                if (ok) {
                  _context5.n = 2;
                  break;
                }
                showError('Expected hex signature bytes');
                return _context5.a(2);
              case 2:
                _context5.p = 2;
                if (!(((_this$mod3 = _this.mod) === null || _this$mod3 === void 0 ? void 0 : _this$mod3.workflow) === 'unlock')) {
                  _context5.n = 3;
                  break;
                }
                _context5.n = 3;
                return _this.resolveSignableMessage(message);
              case 3:
                clearError();
                _context5.n = 4;
                return _this.applySignature(next);
              case 4:
                _context5.n = 6;
                break;
              case 5:
                _context5.p = 5;
                _t2 = _context5.v;
                showError(_t2.message || String(_t2));
              case 6:
                return _context5.a(2);
            }
          }, _callee5, null, [[2, 5]]);
        })));
      }
    }
  }]);
}();
module.exports = SignatureFieldOverlay;